import {
  listComponentValidations,
  addComponentValidation,
  updateComponentValidation,
  removeComponentValidation
} from "../../designer-validation-input-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const validationInputTools: ToolHandlerGroup = {
  sync: {
    ui_common_list_validations: (input) => listComponentValidations(getSdInstance(), input),
    ui_common_add_validation: (input) => addComponentValidation(getSdInstance(), input),
    ui_common_update_validation: (input) => updateComponentValidation(getSdInstance(), input),
    ui_common_remove_validation: (input) => removeComponentValidation(getSdInstance(), input)
  }
};
